// https://parceljs.org/features/dependency-resolution/#glob-specifiers
export const asyncLanguages: Record<string, () => unknown> = {
	cs: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-cs" */ '../../../i18n/cs'),
	da: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-da" */ '../../../i18n/da'),
	de: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-de" */ '../../../i18n/de'),
	'en-GB': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-en_GB" */ '../../../i18n/en_GB'
		),
	'en-ZZ': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-en_ZZ" */ '../../../i18n/en_ZZ'
		),
	en: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-en" */ '../../../i18n/en'),
	es: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-es" */ '../../../i18n/es'),
	fi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-fi" */ '../../../i18n/fi'),
	fr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-fr" */ '../../../i18n/fr'),
	hu: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-hu" */ '../../../i18n/hu'),
	it: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-it" */ '../../../i18n/it'),
	ja: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-ja" */ '../../../i18n/ja'),
	ko: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-ko" */ '../../../i18n/ko'),
	nb: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-nb" */ '../../../i18n/nb'),
	nl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-nl" */ '../../../i18n/nl'),
	pl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-pl" */ '../../../i18n/pl'),
	'pt-BR': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-pt_BR" */ '../../../i18n/pt_BR'
		),
	ru: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-ru" */ '../../../i18n/ru'),
	sv: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-sv" */ '../../../i18n/sv'),
	th: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-th" */ '../../../i18n/th'),
	tr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-tr" */ '../../../i18n/tr'),
	uk: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-uk" */ '../../../i18n/uk'),
	vi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-vi" */ '../../../i18n/vi'),
	zh_TW: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-zh_TW" */ '../../../i18n/zh_TW'
		),
	zh: () =>
		import(/* webpackChunkName: "@atlaskit-internal_global-invite-i18n-zh" */ '../../../i18n/zh'),
};
